import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  TextField,
} from '@material-ui/core';
import * as events from '../../../events';
import * as actions from '../../../state';

import styles from './styles.module.css';
import LoginMessageSnackbar from './LoginMessageSnackbar';

const messages = defineMessages({
  ANALYTICS: {
    id: 'ANALYTICS',
    defaultMessage: 'Analytics',
  },
  LOGO: {
    id: 'LOGO',
    defaultMessage: 'Logo',
  },
  SECURITY_CODE_REQUIRED: {
    id: 'SECURITY_CODE_REQUIRED',
    defaultMessage: 'Security code required',
  },
  LOGIN_NAME: {
    id: 'LOGIN_NAME',
    defaultMessage: 'Login Name',
  },
  SECURITY_CODE: {
    id: 'SECURITY_CODE',
    defaultMessage: 'Security Code',
  },
  ENTER_SECURITY_CODE: {
    id: 'ENTER_SECURITY_CODE',
    defaultMessage: 'Enter the security code generated by your authentication application.',
  },
  SUBMIT: {
    id: 'SUBMIT',
    defaultMessage: 'Submit',
  },
});

function MfaForm({
  intl,
  username,
  mfa_type, // eslint-disable-line camelcase
  mfa_vendor, // eslint-disable-line camelcase
}) {
  const dispatch = useDispatch();

  const loginImage = useSelector(actions.selectLoginImage);

  const [passcode, setPasscode] = useState('');
  const [passcodeErr, setPasscodeErr] = useState('');
  const [authAttempted, setAuthAttempted] = useState(false);

  const onPasscodeChange = (e) => {
    setPasscode(e.target.value);

    if (!e.target.value) {
      setPasscodeErr(intl.formatMessage({ ...messages.SECURITY_CODE_REQUIRED }));
    } else {
      setPasscodeErr('');
    }
  };

  const mfaSubmit = (e) => {
    e.preventDefault();

    if (!passcode) {
      setPasscodeErr(intl.formatMessage({ ...messages.SECURITY_CODE_REQUIRED }));
      setAuthAttempted(true);
    } else {
      dispatch(events.mfaSubmit(
        passcode,
        username,
        mfa_type,
        mfa_vendor,
      ));
    }
  };

  return (
    <div className={`${styles.loginCard} animate__animated animate__fadeIn`}>
      <Card className={styles.card}>
        <CardMedia
          className={styles.media}
          image={loginImage}
          title={intl.formatMessage({ ...messages.LOGO })}
        />

        <CardContent className={styles.content} classes={{ root: styles.loginFormCard }}>
          <div style={{ color: '#333' }}>
            <FormattedMessage {...messages.ENTER_SECURITY_CODE} />
          </div>

          <form onSubmit={mfaSubmit} noValidate style={{ marginTop: '7px' }}>
            <TextField
              required
              id="passcode"
              type="text"
              onFocus={() => setAuthAttempted(false)}
              className={styles.textField}
              onBlur={onPasscodeChange}
              onChange={onPasscodeChange}
              label={intl.formatMessage({ ...messages.SECURITY_CODE })}
              error={authAttempted && Boolean(passcodeErr)}
            />
            <Button
              fullWidth
              size="large"
              type="submit"
              color="primary"
              variant="contained"
              className={styles.loginBtn}
            >
              <FormattedMessage {...messages.SUBMIT} />
            </Button>
          </form>
        </CardContent>
      </Card>

      <LoginMessageSnackbar />

    </div>
  );
}

export default injectIntl(MfaForm);
